module.exports = __webpack_public_path__ + "img/comment.67fe1315.svg";